import Component from "../../lib/component";
import Tracker from "../../lib/tracker";
import {formattedExitCategory, formattedExitDestination} from "./exit_helpers";
import {getTrackerOptions} from "../../lib/tracker_helpers";

export const ExternalLinkConfig = {
    componentTypeKey: 'ExternalLink',
    baseHtmlClass: 'external_link',
    selector: 'a.external_link',

    datasetConfigKey: 'external_link__config',

    categoryPrefix: 'OUTBOUND_LINK',
    defaultMethod: 'GET',
    pageExitEventNameKey: 'PAGE_EXIT',
};

export class ExternalLink extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: ExternalLinkConfig
        });

        this.setDatasetConfig(ExternalLinkConfig.datasetConfigKey);

        const trackerOptions = getTrackerOptions({
            is_native_app: this.datasetConfig['is_native_app'],
            native_app_platform: this.datasetConfig['native_app_platform'],
            native_app_version: this.datasetConfig['native_app_version'],
            native_app_url_scheme: this.datasetConfig['native_app_url_scheme'],
            native_event_host: this.datasetConfig['native_event_host'],
            native_event_endpoint: this.datasetConfig['native_event_endpoint']
        });

        this.tracker = new Tracker(window, document, trackerOptions);

        this.eventName = this.tracker.eventNames[ExternalLinkConfig.pageExitEventNameKey];
        if (typeof this.eventName === 'undefined') console.warn("[ExternalLink] Event name could not be found! Available options are: ", this.tracker?.eventNames);

        this.element.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
        event.preventDefault(); // Prevent default link behavior immediately
        this.trackExitEvent();
        setTimeout(() => {
            window.location.href = this.getUrl(); // Navigate after a delay
        }, 250); // Delay is to allow the event to be tracked before navigating
    }

    trackExitEvent() {
        if (!this.tracker || !this.tracker.eventTracker || !this.eventName) return;
        this.tracker.eventTracker(this.eventName, this.getAnalyticsParameters());
    }

    getAnalyticsParameters() {
        return {
            exit_category: this.getExitCategory(),
            exit_destination: this.getExitDestination()
        }
    }

    getExitCategory() {
        const category = this.element.getAttribute('data-external_category');
        return formattedExitCategory(ExternalLinkConfig.categoryPrefix, category);
    }

    getExitDestination() {
        return formattedExitDestination(this.getUrl(), this.getMethod());
    }

    getUrl() {
        let url = this.getDatasetConfigValue('external_url');
        if (url == null) {
            this.element.getAttribute('data-external_url');
        }
        if (url == null) {
            url = this.element.getAttribute('href')
        }
        if (url == null) {
            url = ''
        }
        return url;
    }

    getMethod() {
        let method = this.element.getAttribute('method');
        if (method == null || method === '') {
            method = ExternalLinkConfig.defaultMethod
        }
        return method.toUpperCase();
    }


}
